export default "__VITE_ASSET__CTNm5dMy__"